// inviteFriend
export default {
  inviteFriend: '邀请好友',
  shareTitle: '邀请好友，立赚现金',
  shareDesc: '每邀1位好友赚350港元，多邀多得！达标额外享V3会员',

  activityTips: '限邀新用户，新用户需首次入金≥20,000 HKD，股票交易≥1笔',
  hkUsMarket: '港美股',
  lifeFreeCommission: '终身免佣',
  inviteNow: '立即邀请',
  myInviteLink: '我的邀请链接',
  myInvite: '我的邀请',
  accumulatedRewards: '累计获得奖励',
  inviteNum: '邀请人数',
  all: '全部',
  registered: '已注册',
  accountOpened: '已开户',
  deposited: '入金达标',
  traded: '已交易',
  viewInviteDetails: '查看邀请详情',
  inviteRecord: '邀请记录',
  inviteDetail: '邀请详情',

  cardOneTitle: '一次邀请，多重奖励.',
  cardOneLabel1: '邀请好友加入盈宝，每位奖励',
  cardOneDesc1: '好友首次入金≥20,000 HKD，股票交易≥1笔',
  cardOneLabel2: '邀请好友交易达标，每位奖励',
  cardOneDesc2: '好友30天内不出金且股票交易次数≥10笔',
  cardOneLabel3: '邀请好友数≥6人',
  cardOneDesc3: '好友需入金≥20,000 HKD，股票交易≥1笔',

  cardTwoTitle: '如何邀请',
  cardTwoStep1: '分享好友',
  cardTwoStep2: '注册开户',
  cardTwoStep3: '好友入金',

  userNickName: '用户昵称',
  inviteTime: '邀请时间',
  inviteStatus: '邀请状态'
}
